module.exports = {"failed":"登录信息与系统记录不匹配。","throttle":"尝试登录次数过多。请在:seconds秒后重试。"};